import React, { Fragment, useState } from "react";
import { Block } from "baseui/block";
import TemplateParameterDetailHeaderView from "./TemplateParameterDetailHeaderView";
import TemplateParameterDetailMainView from "./TemplateParameterDetailMainView";


export default function TemplateParameterDetailView(props) {
  const [childKey, setitemschildKey] = useState(7);

  const handleItemsChanged = () => {
    // setfieldItems(newItems);
    props.onItemsChanged();
    setitemschildKey(childKey * 89);
  };
  return (
    <Fragment>
      <TemplateParameterDetailHeaderView
        onItemsChanged={() => handleItemsChanged()}
      />
       <Block $style={{ height: '20px' }}></Block>
      <TemplateParameterDetailMainView
        key={childKey}
        onItemsChanged={() => handleItemsChanged()}
      />
    </Fragment>
  );
}
